import { useTranslation } from "react-i18next";
import { initI18n } from "./i18n";
import { PlusIcon } from "@heroicons/react/outline";

initI18n();

function AppOnboardingConnect() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center gap-10">
      <div className="flex flex-col items-center">
        <div className="font-gilroy font-semibold text-gray-600 text-3xl">{t("Connect HubSpot to Portant")}</div>
        <div className="font-semibold text-sm text-gray-400 text-center w-[600px]">{t("Allow portant to use your HubSpot data to personalize documents, then associate and save them in HubSpot records")}</div>
      </div>
      <div className="flex items-center justify-center gap-16">
        <img src="https://static.portant.co/hubspot-icon.svg" className="h-16" alt="HubSpot Logo" />
        <PlusIcon className="h-8 text-gray-400" />
        <img src="https://static.portant.co/logo-mark-blue.svg" className="h-16" alt="Portant Logo" />
      </div>
      <a className="btn btn-blue w-40" href={process.env.REACT_APP_INSTALL_URL}>
        Connect
      </a>
    </div>
  );
}

export default AppOnboardingConnect;
